import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { Helmet } from "react-helmet-async";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../styles/materialPagination";
import { StyledReservedBalanceHistoryWrapper } from "../../../wallets/styledWallets";
import { useTranslation } from "react-i18next";
import ReservedBalanceHistoryFilter from "../../../wallets/client/reservedBalanceHistory/ReservedBalanceHisotryFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ReservedBalanceHistoryList from "../../../wallets/client/reservedBalanceHistory/ReservedBalanceHistoryList";

const ReservedBalanceHistoryContainer = ({ match}) => {
  const { t } = useTranslation("walletsPage");

  const history = useHistory();

  const [reservedBalanceHistory, setReservedBalanceHistory] = useState(null);
  const [totalReservedBalance, setTotalReservedBalance] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "reservedBalance", false, true),
    "id": checkFilterItem(history, "id", ""),
    "status": checkFilterItem(history, "status", null),
    "transactionType": checkFilterItem(history, "transactionType", null),
    "dateFrom": checkFilterItem(history, "dateFrom", null, true),
    "dateTo": checkFilterItem(history, "dateTo", null, true),
  });

  const fetchReservedBalanceHistory = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/reserved-balance/history" + filterUrl + "&userId=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setReservedBalanceHistory(response.data.transactions);
        setTotalPageCount(response.data.totalPageCount);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const fetchReservedBalancesAmount = () => {
    axios.get("/api/reserved-balances?user.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setTotalReservedBalance(response.data["hydra:member"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchReservedBalancesAmount();
  }, []);

  useEffect(() => {
    fetchReservedBalanceHistory();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <StyledReservedBalanceHistoryWrapper>
      <Helmet>
        <title>{t("reservedBalance.meta.title")}</title>
      </Helmet>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="reserved-balance-head">
        <div className="reserved-balance-head__left">
          <ReservedBalanceHistoryFilter
            t={t}
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <div className="reserved-balance-amount">
        {t("reservedBalance.totalBalance")} {totalReservedBalance?.[0]?.amount ?? "0"} USDT
      </div>
      <ReservedBalanceHistoryList
        reservedBalanceHistory={reservedBalanceHistory}
        notification={notification}
        setNotification={setNotification}
        t={t}
      />
      {totalPageCount > 1 &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </StyledReservedBalanceHistoryWrapper>
  );
};

export default ReservedBalanceHistoryContainer;